import Hero from './src/pages/HeroSaga/Hero';
import HeroCreate from './src/pages/HeroSaga/Hero/HeroCreate';
import HeroUpdate from './src/pages/HeroSaga/Hero/HeroUpdate';
import Rank from './src/pages/HeroSaga/Rank';
import RankCreate from './src/pages/HeroSaga/Rank/RankCreate';
import RankUpdate from './src/pages/HeroSaga/Rank/RankUpdate';
import Passive from './src/pages/HeroSaga/Passive';
import PassiveUpdate from './src/pages/HeroSaga/Passive/PassiveUpdate';
import PassiveCreate from './src/pages/HeroSaga/Passive/PassiveCreate';
import Trait from './src/pages/HeroSaga/Trait';
import TraitUpdate from './src/pages/HeroSaga/Trait/TraitUpdate';
import TraitCreate from './src/pages/HeroSaga/Trait/TraitCreate';
import BasicStat from './src/pages/HeroSaga/BasicStat';
import Equipment from './src/pages/HeroSaga/Equipment';
import EquipmentUpdate from './src/pages/HeroSaga/Equipment/EquipmentUpdate';
import EquipmentCreate from './src/pages/HeroSaga/Equipment/EquipmentCreate';
import Dice from './src/pages/HeroSaga/Dice';
import DiceUpdate from './src/pages/HeroSaga/Dice/DiceUpdate';
import DiceCreate from './src/pages/HeroSaga/Dice/DiceCreate';
import Alignment from './src/pages/HeroSaga/Alignment';
import AlignmentUpdate from './src/pages/HeroSaga/Alignment/AlignmentUpdate';
import Boon from './src/pages/HeroSaga/Boon';
import BoonUpdate from './src/pages/HeroSaga/Boon/BoonUpdate';

const MenuHeroSaga = [
    {
        id: 'hero',
        name: 'Hero',
        icon: 'icon-puzzle',
        path: 'hero',
        component: Hero,
        isShown: 1,
    },
    {
        path: 'hero/create',
        name: 'Hero > Create',
        component: HeroCreate,
        isShown: 0,
    },
    {
        path: 'hero/update/:id',
        name: 'Hero > Update',
        component: HeroUpdate,
        isShown: 0,
    },
    {
        id: 'rank',
        name: 'Rank',
        icon: 'icon-chart',
        path: 'rank',
        component: Rank,
        isShown: 1,
    },
    {
        path: 'rank/create',
        name: 'Rank > Create',
        component: RankCreate,
        isShown: 0,
    },
    {
        path: 'rank/update/:id',
        name: 'Rank > Update',
        component: RankUpdate,
        isShown: 0,
    },
    // {
    //     id: 'passive',
    //     name: 'Passive',
    //     icon: 'icon-cloud-download',
    //     path: 'passive',
    //     component: Passive,
    //     isShown: 1,
    // },
    // {
    //     path: 'passive/create',
    //     name: 'Passive > Create',
    //     component: PassiveCreate,
    //     isShown: 0,
    // },
    // {
    //     path: 'passive/update/:id',
    //     name: 'Passive > Update',
    //     component: PassiveUpdate,
    //     isShown: 0,
    // },
    {
        id: 'basicStat',
        name: 'Basic Stat',
        icon: 'icon-disc',
        path: 'basic-stat',
        component: BasicStat,
        isShown: 1,
    },
    {
        id: 'trait',
        name: 'Trait',
        icon: 'icon-cup',
        path: 'trait',
        component: Trait,
        isShown: 1,
    },
    {
        path: 'trait/create',
        name: 'Trait > Create',
        component: TraitCreate,
        isShown: 0,
    },
    {
        path: 'trait/update/:id',
        name: 'Trait > Update',
        component: TraitUpdate,
        isShown: 0,
    },
    
    // {
    //     id: 'alignment',
    //     name: 'Alignment',
    //     icon: 'icon-magic-wand',
    //     path: 'alignment',
    //     component: Alignment,
    //     isShown: 1,
    // },
    // {
    //     path: 'alignment/update/:id',
    //     name: 'Alignment > Update',
    //     component: AlignmentUpdate,
    //     isShown: 0,
    // },
    // {
    //     id: 'boon',
    //     name: 'Boon',
    //     icon: 'icon-fire',
    //     path: 'boon',
    //     component: Boon,
    //     isShown: 1,
    // },
    // {
    //     path: 'boon/update/:id',
    //     name: 'Boon > Update',
    //     component: BoonUpdate,
    //     isShown: 0,
    // },
];

export default MenuHeroSaga;
